import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Alert from '@material-ui/lab/Alert';
import { Box } from '@material-ui/core';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import Main from 'components/templates/Main';
import PATHS from 'constants/paths';
import history from 'logic/history';
import ComplaintDetail from '../components/ComplaintDetail';
import {
  fetchComplaintRequest,
  withdrawComplaintRequest,
  respondComplaintRequest,
  complaintsReset,
} from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

const ComplaintDetailContainer = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showExistingBanner, setShowExistingBanner] = React.useState(() =>
    new URLSearchParams(location.search).has('existing'),
  );
  const error = useSelector(selectors.error);
  const isLoading = useSelector(selectors.isLoading);
  const isUpdating = useSelector(selectors.isUpdating);
  const conflict = useSelector(selectors.conflict);
  const complaint = useSelector(selectors.detail);
  const success = useSelector(selectors.success);

  React.useEffect(() => {
    dispatch(fetchComplaintRequest({ id }));
    return () => dispatch(complaintsReset());
  }, [id]);

  const handleEdit = () => {
    history.push(`${PATHS.complaints.root}/${id}/edit`);
  };

  const handleWithdraw = () => {
    dispatch(withdrawComplaintRequest({ id, updated_at: complaint.updated_at }));
  };

  const handleRespond = (data) => {
    dispatch(respondComplaintRequest({ id, data: { ...data, updated_at: complaint.updated_at } }));
  };

  const title = (
    <div>
      <IconButton color="inherit" component={Link} to={PATHS.complaints.root}>
        <ArrowBack />
      </IconButton>
      <FormattedMessage id="complaints.detail" defaultMessage="Complaint" />
      {complaint && ` #${complaint.id}`}
    </div>
  );

  return (
    <Main title={title}>
      {showExistingBanner && (
        <Box mb={2}>
          <Alert severity="info" onClose={() => setShowExistingBanner(false)}>
            <FormattedMessage
              id="complaints.existingComplaint"
              defaultMessage="You have already submitted a complaint for this booking."
            />
          </Alert>
        </Box>
      )}
      <ComplaintDetail
        complaint={complaint}
        isLoading={isLoading}
        isUpdating={isUpdating}
        conflict={conflict}
        onEdit={handleEdit}
        onWithdraw={handleWithdraw}
        onRespond={handleRespond}
      />
      <Success success={success} />
      <Errors errors={error} />
    </Main>
  );
};

export default ComplaintDetailContainer;
